import React from 'react';

import { Box, CircularProgress, circularProgressClasses } from '@mui/material';

import { IDoubleCircularProgressProps } from './types';

export const DoubleCircularProgress: React.FC<IDoubleCircularProgressProps> = ({ size, ...restProps }) => {
  return (
    <Box sx={{ display: 'flex', position: 'relative' }}>
      <CircularProgress
        variant="determinate"
        sx={{ color: (theme) => theme.palette.grey[300] }}
        value={100}
        size={size}
      />
      <CircularProgress
        variant="determinate"
        color="warning"
        sx={{
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={size}
        {...restProps}
      />
    </Box>
  );
};
